/**
 * Module Client #06 — Mes documents
 * Source : Guide_Client_Baobab_Connect.pdf · Chapitre 3.3
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const IMG = (name) => `${BACKEND}/api/uploads/docs/html_assets/client/${name}`;

const moduleClientDocuments = {
  id: 'client-mes-documents',
  population: 'client',
  order: 6,
  category: 'Documents',
  title: 'Mes documents',
  subtitle: 'Centraliser BL, BD, photos et certificats OHADA en un seul lieu',
  icon: 'FileText',
  duration: '15 min',
  level: 'Débutant',
  audience: 'Tous utilisateurs client',
  slides: [
    { type: 'cover', eyebrow: 'Module 06 — Client', title: 'Mes documents', subtitle: 'Coffre-fort numérique opérationnel', icon: 'FileText', duration: '15 min', audience: 'Tous utilisateurs', level: 'Débutant' },
    { type: 'intro', title: 'Objectifs', intro: 'Le module Documents centralise toutes les pièces générées par vos opérations.', objectives: [
      'Consulter et télécharger les BL, BC et BD de vos opérations',
      'Filtrer par type, statut, période, opération associée',
      'Visualiser les photos chargement/déchargement',
      'Récupérer les certificats OHADA et CMR signés',
      'Comprendre la durée légale de conservation (10 ans)',
    ]},
    { type: 'concept', eyebrow: 'Vocabulaire', icon: 'BookOpen', title: 'Les types de documents',
      lede: 'Chaque opération génère plusieurs pièces juridiquement opposables :',
      bullets: [
        '📋 BL (Bon de Livraison) : preuve de remise de marchandise au destinataire',
        '📦 BC (Bon de Chargement) : signé au départ par expéditeur + chauffeur',
        '📤 BD (Bon de Déchargement) : signé à l\'arrivée par destinataire + chauffeur',
        '📸 Photos : marchandises avant/après, scellés, plaques d\'immatriculation',
        '📜 Certificats : CMR (transport international), OHADA conformité',
      ],
      note: 'Tous les PDFs sont signés numériquement (SHA-256) et opposables juridiquement.',
    },
    { type: 'screenshot', eyebrow: 'Vue d\'ensemble', title: 'La page « Mes documents »',
      image: IMG('img_client_mes_documents.png'),
      callouts: [
        { label: 'Filtres rapides', text: 'Par type, statut, période — vues sauvegardées disponibles.', x: 50, y: 50 },
        { label: 'Vue liste / grille', text: 'Bascule en haut à droite — grille pour parcours visuel.', x: 90, y: 45 },
        { label: 'Recherche', text: 'Cherche par n° opération, plaque, ou nom de fichier.', x: 50, y: 45 },
      ],
    },
    { type: 'steps', title: 'Télécharger un BL signé en 3 clics', steps: [
      { title: 'Ouvrir « Mes documents »', detail: 'Menu de gauche, section Finances/Documents.' },
      { title: 'Filtrer "Type = BL signé"', detail: 'Affichage instantané des bons disponibles.' },
      { title: 'Cliquer sur l\'icône Télécharger', detail: 'Le PDF s\'ouvre dans un nouvel onglet.' },
    ]},
    { type: 'comparison', title: 'Bonnes pratiques', do: [
      'Vérifier la signature électronique avant impression',
      'Conserver une copie sur votre archivage interne',
      'Joindre le BL signé aux factures pour vos audits comptables',
      'Utiliser le filtre "Période" lors d\'inspections fiscales',
    ], dont: [
      'Ne supprimez jamais un document signé (10 ans légal)',
      'Ne modifiez pas le PDF (cassure d\'intégrité)',
      'Ne partagez pas les liens publics — utilisez l\'export sécurisé',
      'N\'imprimez pas sans logo Baobab visible',
    ]},
    { type: 'quiz', title: 'Quiz #1',
      question: 'Combien de temps devez-vous conserver les bons signés ?',
      options: ['1 an', '5 ans', '10 ans (OHADA)', 'Indéfiniment'],
      answerIndex: 2,
      explanation: 'L\'OHADA impose 10 ans de conservation pour toutes les pièces justificatives transport.',
    },
    { type: 'quiz', title: 'Quiz #2',
      question: 'Vous avez besoin du BD d\'une opération précise pour votre comptable. Quelle méthode ?',
      options: [
        'Demander à l\'opérateur Baobab par téléphone',
        'Filtrer par numéro d\'opération + Type=BD, puis télécharger',
        'Refaire l\'opération',
        'Imprimer toute la liste',
      ],
      answerIndex: 1,
      explanation: 'Recherche par n° d\'opération est la voie la plus rapide. Le BD est dispo dès la livraison signée.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'Tous les documents sont automatiquement archivés à la signature.',
      'Conservation 10 ans OHADA — ne supprimez rien.',
      'Filtres puissants : par type, opération, période.',
      'Photos chargement/déchargement = preuves visuelles légales.',
      'PDF signés numériquement = opposables sans autre validation.',
    ]},
    { type: 'cta', title: 'Module 06 terminé !', subtitle: 'Vous maîtrisez votre coffre-fort documentaire.',
      actions: [
        { label: 'Ouvrir mes documents', href: '/mes-documents' },
        { label: 'Mes bons signés', href: '/mes-bons' },
        { label: 'Catalogue', href: '/docs/client/training' },
      ],
    },
  ],
};

export default moduleClientDocuments;
